import React from 'react';

import EvaluacionNivelView from '../components/evaluaciones/EvaluacionNivelView';
import { obtenerModulosNivel } from '../config/evaluacionesCatalogo';
import M6_Ejercicio6 from '../components/evaluaciones/Intermedio/Modulo6/M6_Ejercicio6';
import M6_Ejercicio7 from '../components/evaluaciones/Intermedio/Modulo6/M6_Ejercicio7';
import M6_Eje_Retencion from '../components/evaluaciones/Intermedio/Modulo6/M6_Eje_Retencion';
import M7_Ejercicio6 from '../components/evaluaciones/Intermedio/Modulo7/M7_Ejercicio6';
import M7_Ejercicio7 from '../components/evaluaciones/Intermedio/Modulo7/M7_Ejercicio7';
import M7_Ejercicio8 from '../components/evaluaciones/Intermedio/Modulo7/M7_Ejercicio8';
import M7_Eje_Comprension from '../components/evaluaciones/Intermedio/Modulo7/M7_Eje_Comprension';
import M8_Ejercicio7 from '../components/evaluaciones/Intermedio/Modulo8/M8_Ejercicio7';
import M8_Ejercicio8 from '../components/evaluaciones/Intermedio/Modulo8/M8_Ejercicio8';
import M8_Ejercicio9 from '../components/evaluaciones/Intermedio/Modulo8/M8_Ejercicio9';
import M8_EjercicioRetencion from '../components/evaluaciones/Intermedio/Modulo8/M8_EjercicioRetencion';
import M9_Ejercicio6 from '../components/evaluaciones/Intermedio/Modulo9/M9_Ejercicio6';
import M9_Ejercicio7 from '../components/evaluaciones/Intermedio/Modulo9/M9_Ejercicio7';
import M10_Ejercicio5 from '../components/evaluaciones/Intermedio/Modulo10/M10_Ejercicio5';
import M10_Ejercicio6 from '../components/evaluaciones/Intermedio/Modulo10/M10_Ejercicio6';
import M10_Ejercicio7 from '../components/evaluaciones/Intermedio/Modulo10/M10_Ejercicio7';

const componentes = {
  intermedio_modulo6_1: M6_Ejercicio6,
  intermedio_modulo6_2: M6_Ejercicio7,
  intermedio_modulo6_3: M6_Eje_Retencion,
  intermedio_modulo7_4: M7_Eje_Comprension,
  intermedio_modulo7_5: M7_Ejercicio6,
  intermedio_modulo7_6: M7_Ejercicio7,
  intermedio_modulo7_7: M7_Ejercicio8,
  intermedio_modulo8_8: M8_Ejercicio7,
  intermedio_modulo8_9: M8_Ejercicio8,
  intermedio_modulo8_10: M8_Ejercicio9,
  intermedio_modulo8_11: M8_EjercicioRetencion,
  intermedio_modulo9_12: M9_Ejercicio6,
  intermedio_modulo9_13: M9_Ejercicio7,
  intermedio_modulo10_14: M10_Ejercicio5,
  intermedio_modulo10_15: M10_Ejercicio6,
  intermedio_modulo10_16: M10_Ejercicio7,
};

const modulos = obtenerModulosNivel('intermedio', componentes);

const EvaluacionIntermedia = () => (
  <EvaluacionNivelView nivel="intermedio" titulo="Nivel 2 Intermedio" modulos={modulos} />
);

export default EvaluacionIntermedia;
